exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._277iEuW0GoP38zypmhC3Qe:before{color:\"[theme:redDark, default:#a80000]\"!important}._1wsmR57IVyE7GphBrvxoVF:before{color:\"[theme:green20, default:#0b6a0b]\"!important}html[dir] ._1wsmR57IVyE7GphBrvxoVF:before{margin-bottom:2px}._3bOkcIf-J-mgsEJ-Tpziem:before{color:\"[theme:themePrimary, default:#0078D4]\"!important}", ""]);
// Exports
exports.locals = {
	"redDark": "_277iEuW0GoP38zypmhC3Qe",
	"snooze": "_1wsmR57IVyE7GphBrvxoVF",
	"accounts": "_3bOkcIf-J-mgsEJ-Tpziem"
};